
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.958","height":"27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.509 27a2.434 2.434 0 01-1.733-.719l-3.764-3.77A12.267 12.267 0 013.589 3.593 12.25 12.25 0 0124.453 11.1a12.324 12.324 0 01-1.975 7.934l3.764 3.77a2.461 2.461 0 010 3.471 2.434 2.434 0 01-1.733.725zM12.256 3.067a9.124 9.124 0 00-6.5 2.7 9.227 9.227 0 000 13.015 9.18 9.18 0 0013 0 9.2 9.2 0 00-6.5-15.712z","fill":"#222"}})])
          )
        }
      }
    